// extracted by mini-css-extract-plugin
export default {"content":"tilsals_content__oAjrr"};